export enum Role {
  PATIENT = 'patient',
  DOCTOR = 'doctor',
  SUPER_ADMIN = 'admin',
  NURSE = 'nurse'
}
